<template>
  <v-expansion-panel @change="onPanelToggle()" ref="panel" class="ongoing-expansion-panel">
    <v-expansion-panel-header class="sh-flow-panel-header">
      <table class="sh-flow-panel-header">
        <tr>
          <td class="sh-flow-panel-date-box">
            <div class="sh-flow-panel-day-created">{{ day_created }}</div>
            <div class="sh-flow-panel-month-year">{{ month_year_created }}</div>
          </td>
          <td class="sh-flow-panel-title">
            <div v-if="!flow.title" class="sh-flow-panel-documents">
              <v-icon v-if="flow.signatureLevel === 'advanced'" small color="black darken-4">mdi-check-decagram</v-icon>
              <v-icon v-if="flow.signatureLevel !== 'advanced'" small color="black darken-4">mdi-email</v-icon>
              <span class="sh-flow-panel-document">{{ flow.documents.map( doc => doc.fileName ).join( ', ' ) }}</span>
            </div>
            <div v-if="flow.title" class="sh-flow-panel-title">
              <v-icon v-if="flow.signatureLevel === 'advanced'" small color="black darken-4">mdi-check-decagram</v-icon>
              <v-icon v-if="flow.signatureLevel !== 'advanced'" small color="black darken-4">mdi-email</v-icon>
              <span class="sh-flow-panel-title-text">{{ flow.title }}</span>
            </div>
            <div class="sh-flow-panel-signers">
              <v-icon small color="black darken-4">mdi-account-group</v-icon>
              <span class="sh-flow-panel-signer">{{ flow.signers.map( signer => signer.signerName ).join( ', ' ) }}</span>
            </div>
            <div v-if="!isSigningInvitation" class="sh-flow-panel-signers">
              <v-icon small color="black darken-4">mdi-account-plus</v-icon>
              <span v-if="!isSigningInvitation" class="sh-flow-panel-signer">{{ flow.requester.name }}</span>
            </div>
            <div v-if="isSigningInvitation" class="sh-flow-panel-signers">
              <v-icon small color="black darken-4">mdi-domain</v-icon>
              <span v-if="isSigningInvitation" class="sh-flow-panel-signer">{{  flow.requester.name }} {{ $t( "signedin.From" ) }} {{  flow.requester.groupTitle }}</span>
            </div>
          </td>
        </tr>
      </table>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="ongoing-panel-content">
      <v-progress-circular v-if="loading" indeterminate></v-progress-circular>
      <v-card flat v-if="!!flow_data">
        <v-responsive>
          <v-row class="text-left pt-2 px-5 pb-0">
            <v-col cols="12" sm="6">
              <h4 class="font-weight-bold">{{ $t( "signflow.CreatedByTitle" ) }}</h4>
              <p class="mb-0">{{ flow_data.requester.name }} ({{ flow_data.requester.email }})<br/>
                {{ dateFormat( new Date( flow_data.created ), "dd.mm.yyyy, HH:MM" ) }}</p>
              <h4 v-if="isSigningInvitation" class="font-weight-bold">{{ $t( "signflow.OwnedBy" ) }}</h4>
              <p v-if="isSigningInvitation">{{ flow_data.requester.groupTitle }}</p>
            </v-col>
            <v-col cols="12" sm="6">
              <h4 class="font-weight-bold">{{ $t( "signflow.Documents" ) }}</h4>
              <div v-for="doc in flow_data.documents" class="documents-name-list">
                <v-icon small>mdi-file-pdf-box</v-icon>
                <a :href="downloadLink( doc )" target="_blank">{{ doc.fileName }}</a>
              </div>
            </v-col>
          </v-row>
          <v-row class="text-left px-5 my-0 py-0">
            <v-col cols="12" sm="12" class="my-0 py-0">
              <div class="mt-4" v-if="canAddSigner">
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        class="primary-btn"
                        style="min-width: 32px !important; width: 64px !important; padding: 0 !important; flex: 0 0 auto !important;"
                        v-bind="attrs"
                        v-on="on"
                        @click="addSigner()"
                    >
                      <v-icon>mdi-account-multiple-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("signflow.AddSigner") }}</span>
                </v-tooltip>
              </div>
            </v-col>
          </v-row>
          <v-row class="text-left px-5 mt-0 pt-0">
            <v-col cols="12" sm="12">
              <div class="d-flex align-center justify-space-between mb-0">
                <h4 class="font-weight-bold mb-0 pb-0">{{ $t( 'signflow.SignerStatusTitle' )}}</h4>
              </div>
              <div v-if="pending_me">
                <p v-html="$t( 'signflow.PendingMeAlert' )"></p>
                <p>
                  <v-btn class="primary-btn" @click="goToSign()">{{ $t( "signflow.GoToSign" ) }}</v-btn>
                </p>
              </div>
              <div v-if="pending_others && !isSigningInvitation" class="other-pending-signers">
                <v-list-group class="mt-5">
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title><span v-html="pending_others_alert"/></v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <div>
                    <v-list-item class="py-2" v-for="signer in pending_other_signers"
                                 :key="signer.signerEmail">
                      <v-row class="text-left">
                        <v-col cols="12" sm="6" class="status-signer">
                          <div class="d-flex flex-column flex-sm-row align-start align-sm-center">
                              {{ signer.signerName }} ({{ signer.signerEmail.replace('@', '\u200B@') }})
                            <div class="d-flex align-center mt-2 mt-sm-0" v-if="flow_data.requester.email === current_mail">
                              <v-tooltip bottom>
                                <template v-slot:activator="{on, attrs}">
                                  <v-icon small v-bind="attrs" v-on="on" class="ml-2"
                                          :class="preventUpdateSigner( signer._signer_changed ) ? 'signer-change-icon-inactive' : 'signer-change-icon-active '"
                                          @click="updateSigner( signer )">
                                    mdi-pencil
                                  </v-icon>
                                </template>
                                <span v-if="!preventUpdateSigner( signer._signer_changed )">{{ $t("signflow.EditSigner") }}</span>
                                <span v-if="preventUpdateSigner( signer._signer_changed )">{{ $t("signflow.SignerUpdatedInfo") }}</span>
                              </v-tooltip>
                              <v-tooltip bottom>
                                <template v-slot:activator="{on, attrs}">
                                  <v-icon small v-bind="attrs" v-on="on" class="ml-2"
                                          :class="flow.signers.length === 1 ? 'signer-change-icon-inactive' : 'signer-change-icon-active '"
                                          @click="deleteSigner( signer )">
                                    mdi-trash-can
                                  </v-icon>
                                </template>
                                <span v-if="flow.signers.length !== 1">{{ $t("signflow.DeleteSigner") }}</span>
                                <span v-if="flow.signers.length === 1">{{ $t("signflow.LastSignerNoDelete") }}</span>
                              </v-tooltip>
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="6" class="status-info">
                          <div v-if="signer.loginTime">
                            <v-icon small>mdi-clock-outline</v-icon>
                            {{ $t( 'signflow.SignerStatus1' )}} {{ dateFormat( signer.loginTime, "dd.mm.yyyy, HH:MM" ) }}.
                          </div>
                          <div v-if="!signer.loginTime && flow_data.requester.email !== signer.signerEmail && flow_data.created >= new_card_timestamp">
                            <v-icon small>mdi-dots-horizontal-circle-outline</v-icon>
                            {{ $t( 'signflow.SignerStatus2' )}}
                          </div>
                          <div v-if="!signer.loginTime && flow_data.requester.email !== signer.signerEmail && flow_data.created < new_card_timestamp">
                            <v-icon small>mdi-dots-horizontal-circle-outline</v-icon>
                            {{ $t( 'signflow.SignerStatus5' )}}
                          </div>
                          <div v-if="!signer.loginTime && flow_data.requester.email === signer.signerEmail">
                            <v-icon small>mdi-dots-horizontal-circle-outline</v-icon>
                            {{ $t( 'signflow.SignerStatus4' )}}
                          </div>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item class="py-2" v-for="signer in signed_signers" :key="signer.signerEmail">
                      <v-row class="text-left">
                        <v-col cols="12" sm="6" class="status-signer">
                          {{ signer.signerName }} ({{ signer.signerEmail.replace('@', '\u200B@') }})
                        </v-col>
                        <v-col cols="12" sm="6" class="status-info">
                          <div v-if="signer.signed">
                            <v-icon small>mdi-check</v-icon>
                            {{ $t( 'signflow.SignerStatus3' )}} {{ dateFormat( signer.toc, "dd.mm.yyyy, HH:MM" ) }}</div>
                        </v-col>
                      </v-row>
                    </v-list-item>
                  </div>
                </v-list-group>
              </div>
              <div v-if="pending_others && !isSigningInvitation" class="other-pending-signers">
                <v-list-group class="mt-5" v-if="email_reminders.length > 0">
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title><span>{{ $t( 'signflow.ReminderHistory' )}}</span></v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <div>
                    <v-list-item class="py-2" v-for="email_reminder in email_reminders" :key="email_reminder.reminderTs" >
                        <v-row class="text-left">
                            <v-col cols="12" sm="8">
                                <span class="reminder-history-span">
                                    <span class="font-weight-bold reminder-history-signer-span"> {{
                                        email_reminder.reminder_ts
                                        }} </span>
                                    <span>(</span>
                                    <span :title="signer.signerEmail" class="reminder-history-signer-span"
                                          v-for="(signer, index) in formulateReminderSigners( email_reminder.reminder_list )">
                                        <template
                                                v-if="index !== (formulateReminderSigners( email_reminder.reminder_list ).length -1 )">{{
                                            signer.signerName
                                            }}, &nbsp;
                                        </template>
                                        <template
                                                v-if="index === (formulateReminderSigners( email_reminder.reminder_list ).length -1 )">{{
                                            signer.signerName
                                            }})
                                        </template>
                                    </span>
                                </span>
                            </v-col>
                            <v-col v-if="email_reminder.reminder_sender_mail && email_reminder.reminder_sender_mail !== current_mail" class="hidden-xs-only">
                                <span class="hidden-xs-only reminder-history-span" :title="email_reminder.reminder_sender_mail">{{ $t( "signflow.ReminderSentBy" ) }} {{ email_reminder.reminder_sender_name }}</span>
                            </v-col>
                        </v-row>
                    </v-list-item>
                  </div>
                </v-list-group>
                <p v-if="!isSigningInvitation" class="mt-3" v-html="last_email_reminder"></p>
                <p v-if="!isSigningInvitation && allowSendingEmailReminder">
                  <v-btn class="primary-btn" @click="sendReminders()">{{ $t( "signflow.SendReminders" ) }}
                  </v-btn>
                </p>
                <p v-if="!isSigningInvitation && !allowSendingEmailReminder">
                  <v-tooltip bottom>
                    <template v-slot:activator="{on, attrs}">
                      <button v-bind="attrs" v-on="on" @click.prevent="">
                        <v-btn class="primary-btn" :disabled="!allowSendingEmailReminder">{{ $t( "signflow.SendReminders" ) }}
                        </v-btn>
                      </button>
                    </template>
                    <span>{{ $t("signflow.CanNotSendReminders") }}</span>
                  </v-tooltip>
                </p>
              </div>
              <div v-if="pending_others && isSigningInvitation" class="other-pending-signers">
                <p v-html="pending_others_alert"></p>
              </div>
            </v-col>
          </v-row>
        </v-responsive>
        <v-divider></v-divider>
        <v-card-actions v-if="!isSigningInvitation" class="operation-panel" >
          <v-row no-gutters>
            <v-col cols="12" sm="6" md="4" class="pa-2">
              <v-btn @click="preAbortSignFlow()" class="secondary-btn" block>{{ $t( "signflow.CancelProcess" ) }}</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
      <update-signer-dialog v-if="showUpdateSignerDialog" :resolve="resolveUpdateSigner" :flow="flow_data" :signer="editable_signer" ></update-signer-dialog>
      <add-signer-dialog v-if="showAddSignerDialog" :resolve="resolveAddSigner" :flow="flow_data"></add-signer-dialog>
      <signhero-dialog :message="dialogMessage" :resolve="abortSignFlow" type="prompt" v-if="showPromptDialog" ></signhero-dialog>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
    import dateFormat from "dateformat";
    import Vue from "vue";
    import {globalEvents} from "@cloudlace/client";
    import SignHeroDialog from "../../../../util/SignHeroDialog";
    import UpdateSignerDialog from "../ongoing/_UpdateSignerDialog";
    import AddSignerDialog from "../ongoing/_AddSignerDialog";
    import util from "@/util/util";

    const ONE_MINUTE_IN_MS = 60 * 1000;
    let intervalId;
    let onServerMessage;
    export default {
        name : "sh-ongoing-flow",
        props : {
            flow : Object,
            isSigningInvitation : Boolean,
        },
        data()
        {
            const created = new Date( this.flow.created );
            const createdMonth = created.getMonth() + 1;
            return {
                loading : false,
                current_group_id : $cc_user_info.organization.uuid,
                current_mail : $cc_user_info.email,
                curLocale : util.getLocale(),
                pending_me : false,
                pending_others : false,
                pending_other_signers : [],
                signed_signers : [],
                flow_data : undefined,
                editable_signer : {},
                last_email_reminder : "",
                email_reminders : [],
                pending_others_alert : "",
                signers_maps : {},
                day_created : created.getDate() < 10 ? "0" + created.getDate() : created.getDate(),
                month_year_created : ( createdMonth < 10 ? "0" + createdMonth : createdMonth ) + "." + created.getFullYear(),
                dialogMessage : {
                    title : this.$t( "signflow.CancelProcessDialogTitle" ),
                    text : this.$t( "signflow.CancellationReasonsPlaceHolder" ),
                    cancelText : this.$t( "signflow.ButtonGoBack" ),
                    acceptText : this.$t( "signflow.Confirm" ),
                },
                showPromptDialog : false,
                showUpdateSignerDialog : false,
                showAddSignerDialog: false,
                new_card_timestamp : process.env.VUE_APP_NEW_CARD_RELEASE_TIMESTAMP ? process.env.VUE_APP_NEW_CARD_RELEASE_TIMESTAMP : 1669302900000,
                currentTime : Date.now()
            }
        },
        components : {
            "signhero-dialog" : SignHeroDialog,
            "update-signer-dialog" : UpdateSignerDialog,
            "add-signer-dialog": AddSignerDialog,
        },
        computed : {
            canAddSigner()
            {
                if( !this.flow_data || !this.flow_data.signers ) return false;
                const isRequester = this.flow_data.requester.email === this.current_mail;
                const hasMaxSigners = this.flow_data.maxSigners !== undefined && this.flow_data.maxSigners !== null;
                return isRequester
                       && !this.isSigningInvitation
                       && hasMaxSigners
                       && ( this.flow_data.signers.length < this.flow_data.maxSigners );
            }
        },
        methods : {
            /**
             * Handles the panel opening/closing, triggers data fetch,
             * and scrolls the panel to just beneath the header.
             */
            onPanelToggle()
            {
                const isOpening = !this.$refs.panel.isActive;
                this.retrieveFlowData();
                if( isOpening )
                {
                    setTimeout(() =>
                    {
                        const targetY = this.$el.getBoundingClientRect().top + window.scrollY;
                        if( this.$vuetify && this.$vuetify.goTo ) {
                            this.$vuetify.goTo( targetY, { duration: 300, easing: 'easeInOutCubic' } );
                        }
                        else
                        {
                            window.scrollTo( { top: targetY, behavior: 'smooth' } );
                        }
                    }, 300 );
                }
            },
            /**
             * Date formatter.
             */
            dateFormat : dateFormat,
            /**
             * Pre cancel a sign flow.
             */
            preAbortSignFlow()
            {
                this.showPromptDialog = true;
            },
            /**
             * If confirmed by user, cancel the sign flow.
             *
             * @param reasons
             */
            abortSignFlow( reasons )
            {
                this.showPromptDialog = false;
                if( reasons === false )
                {
                    return;
                }
                this.$store.signFlowClient.abortSignFlow( this.flow.groupId, this.flow.uuid, reasons ).then( r =>
                {
                    this.$inform( this.$t( "pdfsign.SignEventCancelled" ) );
                    this.$emit( "change", "canceled" );
                } ).catch( e =>
                {
                    this.$error( this.$t( "signflow.Error!Unexpected" ) )
                } );
            },
            /**
             * Go to the signing pane.
             */
            goToSign()
            {
                this.$router.push( `/sign?group_id=${this.current_group_id}&invited_group_id=${this.flow.groupId}&process_uuid=${this.flow.uuid}&event_uuid=${this.my_sign_event.uuid}` );
            },
            /**
             * Download link for doc.
             *
             * @param doc
             * @returns {string}
             */
            downloadLink( doc )
            {
                return process.env.VUE_APP_SIGNFLOW_DOWNLOAD_URL
                       + `${this.flow.groupId}/${this.flow.uuid}/${doc.uuid}/${doc.fileName}`;
            },
            /**
             * Send signing reminders to all signers who haven't yet signed.
             */
            sendReminders()
            {
                const text = this.$t( "signflow.EmailReminderSuccess" );
                const acceptText = this.$t( "signflow.Ok" );
                this.$store.signFlowClient.createSignReminders( this.flow.groupId, this.flow.uuid ).then( r =>
                {
                    this.$alert( { text, acceptText } );
                } ).catch( e =>
                {
                    this.$error( this.$t( "signflow.Error!Unexpected" ) )
                } );
            },
            /**
             * Retrieve/refresh sign flow content. If reload is set, don't show loader, just refresh quietly.
             *
             * @param reload
             */
            retrieveFlowData( reload )
            {
                if( reload || !this.$refs.panel.isActive )
                {
                    if( !reload )
                    {
                        this.loading = true;
                    }
                    let prom = ( this.current_group_id === this.flow.groupId ) ? this.$store.signFlowClient.retrieveSignFlow( this.current_group_id, this.flow.uuid ) :
                    this.$store.signFlowClient.retrieveInvitedSignFlow( this.current_group_id, this.flow.groupId, this.flow.uuid );
                    prom.then( r =>
                    {
                        this.loading = false;
                        this.my_sign_event =
                        r.signEvents.filter( signEvent => signEvent.signerEmail === $cc_user_info.email && !signEvent.signed )[ 0 ];
                        this.pending_other_signers = this.sortEventsByName(
                        r.signEvents.filter( signEvent => signEvent.signerEmail !== $cc_user_info.email && !signEvent.signed ) );
                        this.signed_signers = this.sortEventsByName(
                        r.signEvents.filter( signEvent => signEvent.signerEmail !== $cc_user_info.email && signEvent.signed ) );
                        const count = this.pending_other_signers.length;
                        r.signEvents.map( entity => {
                            this.signers_maps[ entity.signerEmail ] = entity.signerName;
                        });
                        this.pending_others = count > 0;
                        this.pending_me = !!this.my_sign_event;
                        const timestamp = r.lastEmailReminder ? dateFormat( r.lastEmailReminder,
                        "dd.mm.yyyy, HH:MM" ) : this.$t(
                        "signflow.NoRemindersYet" );
                        this.pending_others_alert = eval( '`' + this.$t( "signflow.PendingOthersAlert" ) + '`' );
                        this.last_email_reminder = eval( '`' + this.$t( "signflow.LastEmailReminder" ) + '`' );
                        this.flow_data = r;
                        this.flow.signers = this.flow_data.signers;
                        this.email_reminders = r.emailReminders ? r.emailReminders.map( entity => {
                            return { reminder_ts: dateFormat( entity.reminderTs, "dd.mm.yyyy, HH:MM" ),
                            reminder_sender_name: entity.reminderSenderName, reminder_sender_mail: entity.reminderSenderMail,
                                reminder_list : entity.reminderList.join(', ')}
                        }) : [];
                        this.allowSendingEmailReminder = this._checkAllowEmailReminder( this.flow_data );
                    } ).catch( e => this.$error( this.$t( "signflow.Error!Unexpected" ) ) );
                }
            },
            /**
             * Formulate reminders signers.
             * If the signer has been deleted from the list, display "Signer deleted" name in the reminder history.
             *
             * @param emailList
             * @returns {*}
             */
            formulateReminderSigners( emailList )
            {
                const reminderSigners = emailList.split( ", " ).map( email => {
                    return { signerEmail : email, signerName : this.signers_maps[ email ] || this.$t( "signflow.SignerDeleted" )};
                })
                return reminderSigners.sort( ( a, b ) => a.signerName.localeCompare( b.signerName, this.curLocale, { caseFirst: "upper" } ) );
            },
            /**
             * In place sort of arrays of events by signer name
             *
             * @param events {Object[][]}
             * @returns {*}
             */
            sortEventsByName ( events )
            {
                return events.sort( ( a, b ) => a.signerName.localeCompare( b.signerName, this.curLocale, { caseFirst: "upper" } ) );
            },
            /**
             * Check whether email reminder is allowed.
             * Only one reminder is allowed within the past 24 hours.
             *
             * @param process
             * @returns {boolean}
             * @private
             */
            _checkAllowEmailReminder( process )
            {
                if( !process.emailReminders || process.emailReminders.length === 0 )
                {
                    return true;
                }
                const lastEmailReminder = process.emailReminders[ process.emailReminders.length - 1 ];
                return ( Date.now() - lastEmailReminder.reminderTs ) >= 1000 * 60 * 60 * 24;
            },
            /**
             * Reloading content prompted by server message, if it's changed.
             *
             * @param evt {Event}
             * @private
             */
            _onServerMessage( evt )
            {
                const msg = evt.detail;
                if( msg.action_str === "UPDATED" && msg.data_type === "trial_sign_flow" )
                {
                    $cc_user_info.organization.free_basic_processes = msg.response_map.free_basic_processes;
                    $cc_user_info.organization.free_basic_invitations = msg.response_map.free_basic_invitations;
                }
                if( msg.action_str !== "ABORTED" && msg.response_map.processUuid === this.flow.uuid )
                {
                    this.retrieveFlowData( true );
                }
            },
            /**
             * Passcode confirm and then delete the signer
             */
            deleteSigner( signerToDelete )
            {
                if( !signerToDelete || this.flow.signers.length === 1 ) return;
                const code = ("" + (Math.random() * 1000000000)).substring( 1, 5 );
                const text = this.$t( "signflow.ConfirmDeleteSigner" )
                             + '\n\n'
                             + this.$t( "signflow.toProceedEnterCode" )
                             + code;
                const cancelText = this.$t( "signflow.ButtonGoBack" );
                const acceptText = this.$t( "signflow.Confirm" );
                this.$prompt( { text, cancelText, acceptText } ).then( r =>
                {
                    if( r === code )
                    {
                        this.$store.signFlowClient.deleteSignerFromSignflow( this.current_group_id,
                        this.flow.uuid,
                        signerToDelete.uuid ).then( r =>
                        {
                            this.$inform( this.$t( "signflow.SignerDeleted" ) );
                        } ).catch( e => this.$error( this.$t( "signflow.Error!Unexpected" ) ) );
                    }
                    else
                    {
                        this.$warn( this.$t( "signflow.numbersDidNotMatch" ) );
                    }
                } ).catch( e => {} );
            },
            /**
             * Show update signer dialog.
             *
             * @param signer
             */
            updateSigner( signer )
            {
                if( this.preventUpdateSigner( signer._signer_changed ) )
                {
                    return;
                }
                this.editable_signer = signer;
                this.showUpdateSignerDialog = true;
            },
            /**
             * Resolve update signer dialog.
             *
             * @param updated
             */
            resolveUpdateSigner( updated )
            {
                this.showUpdateSignerDialog = false;
                if( updated )
                {
                    this.$inform( this.$t( "signflow.SignerUpdated" ) );
                }
            },
            addSigner()
            {
                this.showAddSignerDialog = true;
            },
            resolveAddSigner( created )
            {
                this.showAddSignerDialog = false;
                if( created )
                {
                    this.$inform( this.$t( "signflow.SignerAdded" ) );
                }
            },
            /**
             * Whether allow signer update for the signer event.
             *
             * @param lastUpdated
             * @returns {boolean}
             */
            preventUpdateSigner( lastUpdated )
            {
                if( !lastUpdated )
                {
                    return false;
                }
                return this.currentTime < lastUpdated + ONE_MINUTE_IN_MS;
            },
        },
        /**
         * Subscribe to relevant server messages.
         */
        mounted()
        {
            this.showPromptDialog = false;
            onServerMessage = this._onServerMessage.bind( this );
            globalEvents.on( "shio-signflow-notification", onServerMessage );
            intervalId = setInterval( () =>
            {
                this.currentTime = Date.now();
            }, 1000 ); // Update every second
        },
        /**
         * Remove server message listener.
         */
        beforeDestroy()
        {
            clearInterval( intervalId );
            globalEvents.remove( "shio-signflow-notification", onServerMessage );
        }
    }
</script>

<style lang="sass">
  @import '../../../../styles/style'

  @media (max-width: 374px)
    .sh-flow-panel-signers
      max-width: 150px

    .sh-flow-panel-documents
      max-width: 150px

  @media (min-width: 375px)
    .sh-flow-panel-signers
      max-width: 190px

    .sh-flow-panel-documents
      max-width: 200px

  @media (min-width: 600px)
    .sh-flow-panel-signers
      max-width: 420px

    .sh-flow-panel-documents
      max-width: 420px

  @media (min-width: 700px)
    .sh-flow-panel-documents
      max-width: 520px

  @media (min-width: 960px)
    .sh-flow-panel-signers
      max-width: 720px

    .sh-flow-panel-documents
      max-width: 720px

  @media (min-width: 1264px)
    .sh-flow-panel-signers
      max-width: 850px

    .sh-flow-panel-documents
      max-width: 950px

  @media (min-width: 1904px)
    .sh-flow-panel-signers
      max-width: 950px

  .other-pending-signers .v-list-item
    min-height: auto !important

  .other-pending-signers .v-list-group
    border: 1px solid $dark-grey
    border-radius: 3px

  .reminder-history-span
    display: inline-block
    width : 100%

  .reminder-history-signer-span
    white-space: nowrap

  .v-btn.v-btn--icon.v-btn--round.theme--light.v-size--default:before
    background-color: white !important

  .signer-change-icon-active
    color: $vivid-pink !important
    cursor: pointer !important

  .signer-change-icon-inactive
    color: $dark-grey !important
    cursor: pointer !important

</style>

<style lang="sass" scoped>
  @media (max-width: 599px)
    button
      width: 100%

    .status-signer
      padding-bottom: 5px

    .status-info
      padding-top: 0

    .add-signer-btn
      min-width: 32px !important
      width: 32px !important
      padding: 0 !important
</style>
